import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import enUsTranslations from './locales/en-US/en-US.json';
import esESTranslations from './locales/es-ES/es-ES.json';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    ns: ['default'],
    fallbackLng: 'en',
    debug: false,
    defaultNS: 'default',
    interpolation: {
      escapeValue: false,
    },
  });

i18n.addResourceBundle('en', 'default', enUsTranslations, true, true);
i18n.addResourceBundle('es', 'default', esESTranslations, true, true);

export default i18n;
